<template>
  <div style="height: 100%">
    <CKeditor
      v-if="sysConfig['base.editor'] === 'CKEditor5'"
      :value="value"
      @update:value="updateValue"
    />
    <WangEditor
      v-if="sysConfig['base.editor'] === 'WangEditor'"
      :value="value"
      @update:value="updateValue"
    />
    <UEditorPlus
      v-if="sysConfig['base.editor'] === 'UEditorPlus'"
      :value="value"
      @update:value="updateValue"
    />
  </div>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import CKeditor from '@/components/CKEditor'
import UEditorPlus from '@/components/UEditorPlus'
import { mapGetters } from 'vuex'

// 聚合编辑器
export default {
  name: 'ComposeEditor',
  components: { WangEditor, CKeditor, UEditorPlus },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['sysConfig'])
  },
  methods: {
    updateValue(e) {
      // console.log('input', e)
      this.$emit('input', e)
    }
  }
}
</script>
